var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"detail-row"},_vm._l((_vm.infoList),function(x,i){return _c('el-col',{key:i,attrs:{"span":x[2] || 12}},[_c('span',[_vm._v(_vm._s(x[0]))]),_c('span',[_vm._v(_vm._s(x[1] || ''))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }